import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const RegisterButton = () => {
    const { loginWithRedirect, isAuthenticated } = useAuth0();

    return (
        !isAuthenticated && <li><a href="/#" onClick={() => loginWithRedirect()}><i className="far fa-edit"/>Register</a></li>
            );
};

export default RegisterButton;